import { memo } from "react";
import type { BlocksPreviewViewerProp } from "@circle-react/components/Spaces/CourseSpace/Lockscreen/BlocksViewer/BlocksPreviewViewer";
import { BlocksPreviewViewer } from "@circle-react/components/Spaces/CourseSpace/Lockscreen/BlocksViewer/BlocksPreviewViewer";
import type { ControlledThemeProviderProps } from "@circle-react/providers";
import { ControlledThemeProvider } from "@circle-react/providers";
import { HeaderPreview } from "@circle-react-shared/Previews";
import { StyledFrame } from "@circle-react-shared/StyledFrame";

export interface LockscreenFrameProps {
  blocks?: BlocksPreviewViewerProp["blocks"];
  headerSpaceEmoji?: string;
  headerSpaceTitle?: string;
  theme?: ControlledThemeProviderProps["theme"];
}

export const LockscreenFrame = memo(
  ({
    theme = {},
    headerSpaceEmoji = "",
    headerSpaceTitle = "",
    blocks = [],
  }: LockscreenFrameProps) => (
    <StyledFrame>
      <ControlledThemeProvider theme={theme}>
        <HeaderPreview
          spaceName={headerSpaceTitle}
          emoji={headerSpaceEmoji}
          hideRightContent
        />
        <BlocksPreviewViewer blocks={blocks} />
      </ControlledThemeProvider>
    </StyledFrame>
  ),
);
LockscreenFrame.displayName = "LockscreenFrame";
